import { Request, PODCASTERS_SERVICE } from '../Request';

export async function isSubscribedToMarketingEmails() {
  const response = await Request.of().get(`${PODCASTERS_SERVICE}/v0/user/subscription`);
  const json = await response.json();
  return json.isSubscribed;
}

export function updateEmailSubscriptionPreference({
  isSubscribed,
  subscriptionToken,
  anonymous,
}: {
  isSubscribed: boolean;
  subscriptionToken?: string;
  anonymous?: boolean;
}) {
  const endpoint = `${PODCASTERS_SERVICE}/v0/user/subscription`;

  if (subscriptionToken) {
    return Request.of({ anonymous }).post(`${endpoint}/${subscriptionToken}`, {
      isSubscribed,
    });
  } else {
    return Request.of({ anonymous }).post(endpoint, { isSubscribed });
  }
}
